import React, { useMemo, useState } from 'react';
import { Button, List, message, Modal, Skeleton, Space, Table } from 'antd';
import tableService from '../../../services/tableService';

const getCourseLabel = (item) => {
  const courseName =
    item.courseName || (item.course && item.course.name) || '\u672a\u547d\u540d\u8bfe\u7a0b';
  return item.enrollDate ? `${courseName} / ${item.enrollDate}` : courseName;
};

const getFeedbackCourseType = (item) => {
  const rawType =
    item.courseType ||
    item.courseTypeName ||
    item.type ||
    item.courseTypeDisplayName ||
    '';
  const rawText = [
    rawType,
    item.courseName,
    item.courseCategory,
    item.courseTypeDisplayName,
    item.content,
  ]
    .filter(Boolean)
    .join(' ');

  if (rawType === 'LECTURE') return 'MIN60';
  if (rawType) return rawType;
  if (/\u7f3a\u5e2d|\u65f7\u8bfe|absent|absence/i.test(rawText)) return 'MISSING';
  if (/\u8bd5\u542c/.test(rawText)) return 'TRAIL';
  if (/group/i.test(rawText)) return 'GROUP';
  if (/45/.test(rawText)) return 'MIN45';
  if (/60/.test(rawText)) return 'MIN60';
  if (/30/.test(rawText)) return 'MIN30';
  return '';
};

const FeedbackTable = (props) => {
  const {
    isLoading,
    oneStudentFeedbackList,
    feedbackTableColumn,
    enrollCourseList = [],
    fetchOneStudentFeedbackList,
  } = props;
  const [movingRecord, setMovingRecord] = useState(null);
  const [moving, setMoving] = useState(false);

  const dataSource = useMemo(() => {
    return (oneStudentFeedbackList || []).map((item, index) => ({
      ...item,
      courseType: getFeedbackCourseType(item),
      lessonIndex: index + 1,
    }));
  }, [oneStudentFeedbackList]);

  const columns = useMemo(() => {
    return (feedbackTableColumn || []).map((column) => {
      if (column.dataIndex !== 'lessonIndex') {
        return column;
      }
      return {
        ...column,
        render: (value, record) => (
          <Space>
            <span>{value}</span>
            <Button size='small' onClick={() => setMovingRecord(record)}>
              挪动
            </Button>
          </Space>
        ),
      };
    });
  }, [feedbackTableColumn]);

  const handleMove = async (targetEnrollment) => {
    if (!movingRecord || !movingRecord.feedbackId) {
      message.error('\u65e0\u6cd5\u627e\u5230\u8fd9\u6761\u4e0a\u8bfe\u8bb0\u5f55');
      return;
    }
    setMoving(true);
    try {
      await tableService.moveFeedback(
        movingRecord.feedbackId,
        targetEnrollment._id
      );
      message.success('\u632a\u52a8\u6210\u529f');
      const currentEnrollment = movingRecord.enrollment;
      setMovingRecord(null);
      if (fetchOneStudentFeedbackList && currentEnrollment) {
        fetchOneStudentFeedbackList(currentEnrollment);
      }
    } catch (error) {
      message.error('\u632a\u52a8\u5931\u8d25');
    } finally {
      setMoving(false);
    }
  };

  return isLoading ? (
    <Skeleton active />
  ) : (
    <>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={{
          position: ['topLeft'],
        }}
      />
      <Modal
        title='\u9009\u62e9\u8981\u632a\u5230\u7684\u8bfe\u7a0b'
        visible={!!movingRecord}
        footer={null}
        onCancel={() => setMovingRecord(null)}
      >
        <List
          loading={moving}
          dataSource={(enrollCourseList || []).filter(
            (item) => String(item._id) !== String(movingRecord?.enrollment)
          )}
          locale={{ emptyText: '\u6ca1\u6709\u5176\u4ed6\u8bfe\u7a0b' }}
          renderItem={(item) => (
            <List.Item
              actions={[
                <Button
                  type='primary'
                  size='small'
                  onClick={() => handleMove(item)}
                >
                  挪到这里
                </Button>,
              ]}
            >
              {getCourseLabel(item)}
            </List.Item>
          )}
        />
      </Modal>
    </>
  );
};

export default FeedbackTable;
